import { render, staticRenderFns } from "./StudentGoBack.vue?vue&type=template&id=7ab3898a&"
import script from "./StudentGoBack.vue?vue&type=script&lang=js&"
export * from "./StudentGoBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports